import React from "react"
import { Layout } from "../components/layout"
import SEO from "../components/seo"
import { Link, graphql } from "gatsby"
import { linkResolver } from '../utils/linkResolver'
import Img from "gatsby-image"
import { RichText } from 'prismic-reactjs'
import Timeline from "../components/timeline"


export const query = graphql`
query postemplateQuery($uid: String)  {
    prismic {
      allPosts(uid: $uid) {
        edges {
          node {
            title
            timespan
            body
            image
            imageSharp {
              childImageSharp {
                fluid(quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
              }
            }
            _meta {
              uid
              type
            }
            tools {
              tool {
                ... on PRISMIC_Tool {
                  name
                  _meta {
                    uid
                    type
                  }
                }
              }
            }
            topics {
              topic {
                ... on PRISMIC_Topic {
                  title
                  _meta {
                    uid
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default (props) => {
  const doc = props.data.prismic.allPosts.edges[0];
  if (!doc) return null;
  const tools = !doc.node.tools.length > 0 ? <h4>Tools: N/A</h4> : <h4>Tools: {doc.node.tools.map(({ tool: node }, i, arr) => ((arr.length - 1) === i ?
    <Link to={linkResolver(node._meta)} key={i} className="link">{node.name[0].text}.</Link>
    : <Link to={linkResolver(node._meta)} key={i} className="link">{node.name[0].text}, </Link>
  ))}</h4>
  const topics = !doc.node.topics.length > 0 ? <h4>Topics: N/A</h4> : <h4>Topics: {doc.node.topics.map(({ topic: node }, i, arr) => ((arr.length - 1) === i ?
    <Link to={linkResolver(node._meta)} key={i} className="link">{node.title[0].text}.</Link>
    : <Link to={linkResolver(node._meta)} key={i} className="link">{node.title[0].text}, </Link>
  ))}</h4>
  return (
    <div className="body">
      <Layout>
        <SEO title={doc.node.title[0].text} />
        <div className="grid-child intro">
          <div className="text-wrapper">
            <div className="head-image">
              <Img fluid={doc.node.imageSharp.childImageSharp.fluid} />
            </div>
            <h1>{doc.node.title[0].text}</h1>
            <h4>Time: {doc.node.timespan[0].text}</h4>
            {topics}
            {tools}
            <h4 >Summary:</h4>
            <p>{RichText.render(doc.node.body)}<br /></p>
          </div>
        </div>
        <Timeline />
      </Layout>
    </div >
  )
}

